// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"deec5879","239":"955e188a","273":"0a368416","292":"f5d0d200","395":"04811e71","732":"150f72ee","918":"477c1237","977":"a18499d7"}[chunkId] + ".chunk.js";
};